import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { Form } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { validationSchema } from './validation';
import { Alert, Button, Input } from '../../../../UI/Common';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import helper from '../../../../../utils/helper';
import moment from 'moment';
import DeleteRecord from '../../../../UI/DeleteRecord';

const AddLicensePage = ({ t, loading, info, result, ...props }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [actionType, setActionType] = React.useState(1);
  const isRequireConfirmation = helper.isRequireConfirmation();
  const { values, handleChange, touched, errors, ...formik } = useFormik({
    initialValues: {
      license: '',
    },
    validationSchema,
    onSubmit,
  });
  function onSubmit(values) {
    setOpenModal(true);
    // if (isRequireConfirmation) {
    //   setOpenModal(true);
    // } else {
    //   if (actionType === 1) {
    //     props.onValidateLicense(values);
    //   } else {
    //     props.onApplyLicense(values);
    //   }
    // }
  }
  function getLicenseStatus() {
    if (!result) {
      return '';
    } else {
      if (result === 1) {
        if (moment().isSameOrBefore(info.expirationTime)) {
          return <span style={{ color: 'green' }}>VALID</span>;
        }
        return <span style={{ color: 'red' }}>INVALID</span>;
      }
      return <span style={{ color: 'red' }}>INVALID</span>;
    }
  }
  function getLicenseInfo() {
    if (Object.keys(info).length === 0) {
      return '';
    } else {
      return `Department name: ${info.departmentName}\nCreation date: ${info.creationDate}\nExpiration time: ${info.expirationTime}\nSensor count: ${info.sensorCount}\nUser count: ${info.userCount}`;
    }
  }
  if (props.invalidId) {
    return (
      <Backend>
        <div className="content-inner">
          <h1>{t('This department is unavailable')}</h1>
        </div>
      </Backend>
    );
  }
  return (
    <Backend title={`Add License for Department: ${props.dept.name}`}>
      <div className="content-inner">
        <Form>
          <DeleteRecord
            title={actionType === 1 ? 'Validate License' : 'Apply License'}
            body={`Are you sure to ${
              actionType === 1 ? 'validate license' : 'apply license'
            }?`}
            isOpen={openModal}
            onCancel={() => setOpenModal(false)}
            onConfirm={() => {
              setOpenModal(false);
              if (actionType === 1) {
                props.onValidateLicense(values);
              } else {
                props.onApplyLicense(values);
              }
            }}
          />
          {/* <PasswordConfirmation
            isOpen={openModal}
            onCancel={() => setOpenModal(false)}
            onConfirm={() => {
              setOpenModal(false);
              if (actionType === 1) {
                props.onValidateLicense(values);
              } else {
                props.onApplyLicense(values);
              }
            }}
          /> */}
          <Input
            required
            type="textarea"
            inputClass="custom-text-area"
            id="license"
            label="License"
            onChange={handleChange('license')}
            value={values.license}
            invalid={touched.license}
            error={errors.license}
          />
          <Alert.Error text={props.invalid} />
          <Button
            id="validate-license-btn"
            loading={loading}
            onClick={() => {
              setActionType(1);
              formik.handleSubmit();
            }}
            classes="mb-10"
          >
            <i className="md-icon">done</i>
            {t('Validate')}
          </Button>
          <Input
            readOnly
            type="textarea"
            inputStyle={{ lineHeight: 1.5, height: 150, paddingTop: 5 }}
            id="license-valid"
            label={<span>License details {getLicenseStatus()}</span>}
            value={getLicenseInfo()}
          />
          <Alert.Error text={props.errors} />
          <Button
            id="apply-license-btn"
            loading={loading}
            disabled={Object.keys(info).length === 0}
            onClick={() => {
              setActionType(2);
              onSubmit();
            }}
          >
            <i className="md-icon">done</i>
            {t('Apply')}
          </Button>
        </Form>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(AddLicensePage);
